export default {
  // 状态
  STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '启用'
  }, {
    id: 2,
    name: '停用'
  }],
  // 员工状态
  EMPLOYEE_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '在职'
  }, {
    id: 2,
    name: '离职'
  }],
  // 性别
  SEX: [{
    id: 1,
    name: '男'
  }, {
    id: 2,
    name: '女'
  }],
  // 是否
  YES_NO: [{
    id: 1,
    name: '是'
  }, {
    id: 2,
    name: '否'
  }],
  // 有无
  HAVE_STATUS: [{
    id: 1,
    name: '有'
  }, {
    id: 2,
    name: '无'
  }],
  // 咨询状态
  CONSULT_STATUS: [{
      id: 1,
      name: '咨询'
    },
    {
      id: 2,
      name: '转出'
    },
    {
      id: 3,
      name: '已见面'
    },
    {
      id: 4,
      name: '已成交'
    },
    {
      id: 5,
      name: '搁置'
    }
  ],
  // 资源共享状态
  CONSULT_SHARED_STATUS: [{
      id: 1,
      name: '待承接'
    },
    {
      id: 2,
      name: '信息对接中'
    },
    {
      id: 3,
      name: '已承接'
    },
    {
      id: 4,
      name: '已关闭'
    }
  ],
  // 发票类型
	INVOICE_TYPE: [{
		id: 1,
		name: '纸质专票'
	},
	{
		id: 2,
		name: '纸质普票'
	},
	{
		id: 3,
		name: '电子发票'
	}
	],
  // 发票状态
  INVOICE_STATUS: [{
      id: 1,
      name: '待开票'
    },
    {
      id: 2,
      name: '待交接'
    },
    {
      id: 3,
      name: '已交接'
    }
	],
  // 发票状态2
  INVOICE_STATUS2: [{
      id: 1,
      name: '待开票'
    },
    {
      id: 2,
      name: '待交接'
    }
	],
	// 发票交接方式
	INVOICE_HANDOVER_TYPE: [{
		id: 1,
		name: '面对面'
	},
	{
		id: 2,
		name: '快递'
	},
	{
		id: 3,
		name: '邮箱'
	}
	],
  // 客户转账状态
  TRANSFER_STATUS: [{
      id: 1,
      name: '待转账'
    },
    {
      id: 2,
      name: '已转账'
    }
	],
  /**
   * 基础
   * */
  TIP: {
    TITLE: '系统提示',
    SELECT_ONE_FIRST: '请您选择一项，再进行操作',
    SELECT_ONE_LEAST: '请您至少选择一项，再进行操作',
    NO_OPERATION_RECORDS: '无可操作的数据',
    COMMON_ERROR: '出错了，请稍后重试。如果重现此错误，请联系信息部。'
  },
  // 分页信息
  PAGINATION: {
    TOTAL: 0,
    PAGE: 1,
    ROWS: 10,
    MAX_ROWS: 99999999
  },
  // 默认小数保留位
  DECIMAL: {
    DEFAULT_PRECISION: 2,
    DEFAULT_SPEC_PRECISION: 4,
    DEFAULT_MAX_NUM: 9999999.99,
    DEFAULT_SPEC_MAX_NUM: 9999999.9999
  },
  AGENT_MAP: {
    '/elecnotes/upload': 1000004,
    '/elecnotes/manage': 1000004,
    '/consult/manage': 1000004,
    '/consult/consult-edit': 1000004,
    '/invoice/manage': 1000004,
    '/invoice/invoice-edit': 1000004,
    '/consult/resource-development': 1000004,
    '/publicity/publicity': 1000004,
    '/elecnotes/UploadTx': 1000004,
    '/president-mailbox/list': 1000004,
    '/client-in-service/query': 1000004,
    '/test': 9999999,
  },
  WHO: sessionStorage.getItem('who'),
  IMAGE_TYPES: ['jpg', 'png', 'jpeg', 'bmp'],
  EMPTY_MSG: '暂无数据',
  IMG_WIDTH_LIMIT: 1024,
  IMG_HEIGHT_LIMIT: 1024,
  LIVE_RELOAD_INTERVAL: 30, // 页面刷新时间周期（s）
  // uncheck permissions whitelist
  UNCHECK_PERMISSIONS_WHITE_LIST: ['admin', 'sysadmin'],
  COMPANY_NAME: '北京春雪会计服务有限公司',
  SYSTEM_NAME: '春雪服务工作台',
  SYSTEM_SNAME: '春雪会计',
  CX_USER: 'chunxue',
  // 响应成功条件
  IS_RESPONSE_OK: 'resp && resp.data && resp.data.success',
  // 身份证、手机号验证
  REG_EXP: {
    PERSON_NAME: new RegExp('\\S{2,}'),
    ID_CARD: new RegExp('^[1-9]\\d{5}(18|19|20)\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$'),
    MOBILE: new RegExp('^[1]([3-9])[0-9]{9}$')
  },

  // 总裁信箱邮件状态
  PRESIDENT_MAIL_STATUS: [
    { id: 1, name: '1', label: '未回复' },
    { id: 2, name: '2', label: '已回复' },
    { id: 3, name: '3', label: '全部'  }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/const.js